module.exports = __webpack_public_path__ + "static/running_plans-73a4706e21b30dfc3abde67e2d4c4ac4.jpg";